module.exports = __webpack_public_path__ + "static/man_set_7senior.a4142b84.svg";